module.exports = __webpack_public_path__ + "img/Angiogenesis-BRCA_10X_DCIS.487c0ead.png";